export default {
  alert: {
    type: null,
    message: null,
  },
}
